import { render, staticRenderFns } from "./AttendanceExpandItem.vue?vue&type=template&id=352e630c"
import script from "./AttendanceExpandItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendanceExpandItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports